import { ValidationResult } from './getValidator';

export type CheckboxValidation = { required?: boolean };

const getCheckboxValidator =
  ({ required }: CheckboxValidation) =>
  (value: boolean): ValidationResult => {
    if (!required) {
      return undefined;
    } else if (!value) {
      return { key: 'required' };
    } else {
      return undefined;
    }
  };

export default getCheckboxValidator;
